/**
 * @desc 时间戳转换成日期
 * @param timestamp 时间戳
 */
export default function (timestamp) {
  return new Date(parseInt(timestamp) * 1000).toLocaleString().replace(/:\d{1,2}$/,' ') 
}
